// extracted by mini-css-extract-plugin
module.exports = {"invalidColor":"#ea503f","placeholderColor":"#475569","controlColor":"#304958"};